import { styled, Theme } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { EditGuesser } from 'shared/react-admin/Guessers/EditGuesser/EditGuesser';

const getCardStyles = (theme: Theme) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  backgroundColor: theme.palette.background.default,
  padding: '24px',
});

export const StyledEditGuesser = styled(EditGuesser)(({ theme }) => ({
  ...getCardStyles(theme),
  '& .MuiCardContent-root': {
    padding: 0,
  },
  '& .MuiCardContent-root:last-child': {
    padding: 0,
  },
  '& .RaEdit-main': {
    margin: 0,
    alignItems: 'normal',
  },
}));

export const CardBoxStyled = styled(Box)(({ theme }) => ({
  ...getCardStyles(theme),
  display: 'flex',
  flexDirection: 'column',
}));

export const BoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '24px',
});
